jQuery(document).foundation();

jQuery(document).ready(function ($) {



  function isInViewport(node) {
    var rect = node.getBoundingClientRect();
    return (
      (rect.height > 0 || rect.width > 0) &&
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Mobile Menu
  $('#offCanvas').on('opened.zf.offCanvas', function () {
    $('#openOffCanvas').addClass('is-active');
  });

  $('#offCanvas').on('closed.zf.offCanvas', function () {
    $('#openOffCanvas').removeClass('is-active');
  });

  // Fitvids
  if ($(".fitVids").length) {
    $(".fitVids").each(function () {
      $(this).fitVids();
    });
  }


  // Signup Form
  $('form.newsletterForm').on("submit", function (event) {
    event.preventDefault();

    var $form = $(this);
    var $response = $form.find('.newsletterForm__response');
    var $emailInput = $form.find('.newsletterForm__email');
    var $button = $form.find('.button');
    $button.prop('disabled', true);
    $emailInput.removeClass('error');
    $response.hide();
    $response.removeClass('newsletterForm__response--error');

    $.ajax({
      url: '/', type: "POST", data: $(this).serialize(), dataType: "json", success: function (data) {
        if (!data.success) {
          // there was an error
          $response.find('p').html('There was an error submitting the form: ' + data.message);
          $response.addClass('newsletterForm__response--error');
          $emailInput.addClass('error');
          $response.show();

        } else {
          // Success
          $response.find('p').html('Subscribed successfully!');
          $response.show();

        }
        $button.prop('disabled', false);
      }
    });
  });




  // scroll to anchor on click

  var href = location.protocol + '//' + location.host + location.pathname;

  $(document).on('click', 'a[href^="#"],a[href^="'+href+'#"]', function(e) {
      if ($(this).hasClass('accordion-title')) {
          return;
      }
      var idsplit = $(this).attr('href').split('#')[1];
      if (idsplit.length > 0) {
          var $id = $('#'+idsplit);
          if ($id.length === 0) {
              return;
          }
          e.preventDefault();
          $('#offCanvas').foundation('close');
          var headerHeight = $('#header').height();
          var pos = $id.offset().top - headerHeight - 88;
          $('body, html').animate({scrollTop: pos}, 600);
      }
  });

  // scroll to anchor on load

  if (location.hash) {
      var $id = $(location.hash);
      if ($id.length) {
          var headerHeight = $('#header').height();
          var pos = $id.offset().top - headerHeight - 88;
          $('body, html').animate({scrollTop: pos}, 600);
      }
  }

});
